import React from 'react';
import styled from 'styled-components';
import { Section, Container } from '../layout';
import { Title, Header, Paragraph } from '../typography';
import { TestimonialCard } from '../ui';
import { FadeIn } from '../animations';

interface Testimonial {
    quote: string;
    authorName: string;
    authorImage: string;
}

interface TestimonialsSectionProps {
    backgroundColor?: string;
    title: string;
    header: string;
    headerHighlight?: string;
    paragraph: string;
    testimonials: Testimonial[];
}

const SectionHeader = styled.div`
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
    max-width: 800px;
    margin: 0 auto ${({ theme }) => theme.spacing.xxl};
`;

const TestimonialsGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xl};
    max-width: 1000px;
    margin: 0 auto;
`;

export const TestimonialsSection: React.FC<TestimonialsSectionProps> = ({
    backgroundColor,
    title,
    header,
    headerHighlight,
    paragraph,
    testimonials,
}) => {
    return (
        <Section backgroundColor={backgroundColor}>
            <Container>
                <SectionHeader>
                    <FadeIn delay={0}>
                        <Title>{title}</Title>
                    </FadeIn>
                    <FadeIn delay={200}>
                        <Header highlightText={headerHighlight}>{header}</Header>
                    </FadeIn>
                    <FadeIn delay={400}>
                        <Paragraph>{paragraph}</Paragraph>
                    </FadeIn>
                </SectionHeader>
                <TestimonialsGrid>
                    {testimonials.map((testimonial, index) => (
                        <FadeIn key={index} delay={500}>
                            <TestimonialCard
                                quote={testimonial.quote}
                                authorName={testimonial.authorName}
                                authorImage={testimonial.authorImage}
                                imagePosition={index === 1 ? 'right' : 'left'}
                            />
                        </FadeIn>
                    ))}
                </TestimonialsGrid>
            </Container>
        </Section>
    );
};
